






























































































import ChromeDashboard from '@/components/chrome/Dashboard.vue';
import ListBody from '@/components/list/ListBody.vue';
import ListHead from '@/components/list/ListHead.vue';
import ListItem from '@/components/list/ListItem.vue';
import ListWrapper from '@/components/list/ListWrapper.vue';
import { commonActions, getCounts, menuItems } from './constants';

export default {
  mounted() {
    setTimeout(() => {
      this.displayDashboard = true;
    }, 200);

    getCounts()
      .then(response => ({
        components: response.component.aggregate.count,
        materials: response.material.aggregate.count,
        products: response.product.aggregate.count,
        vendors: response.vendor.aggregate.count,
      }))
      .then(response => this.counts = response);
  },
  data: () => ({
    counts: {},
    displayDashboard: false,
    menuItems,
  }),
  computed: {
    gettingStarted: () => commonActions,
  },
  components: {
    ChromeDashboard,
    ListBody,
    ListHead,
    ListItem,
    ListWrapper,
  },
} as IView;
